const pt = {
  //STAGES
  'Qualifying Round': 'Ronda Qualificatória',
  '1st Round': 'Primeira Ronda',
  '2nd Round': 'Segunda Ronda',
  '1st Qualifying Round': 'Primeira ronda eliminatória',
  '2nd Qualifying Round': 'Segunda ronda eliminatória',
  '3rd Qualifying Round': 'Terceira ronda eliminatória',
  'Regular Season': 'Época Regular',
  'Group Stage': 'Fase de Grupos',
  '8th Finals': 'Oitavos de final',
  'Quarter-finals': 'Quartos de final',
  'Semi-finals': 'Meias-Finais',
  //COMPETITION
  'Friendlies': 'Amigável',
  'Club Friendlies': ' Amigável Clubes',
  'Hybrid Friendlies': ' Amigável Híbrido',
  'UEFA Champions League': 'Liga dos Campeões',
  'AFC Champions League': 'AFC Liga dos Campeões',
  'UEFA Europa League': 'Liga Europa',
  "Women's World Cup": 'Mundial Feminino',
  'World Cup': 'Campeonato do Mundo',
  'WC Qualification Europe': 'WC Qualificação Europa',
  'WC Qualification CONCACAF': 'WC Qualificação CONCACAF',
  'WC Qualification South America': 'WC Qualificação América do Sul',
  'WC Qualification Africa': 'WC Qualificação África',
  'Africa Cup of Nations Qualification': 'Nações Africanas Qualificação',
  'UEFA Nations League': 'Liga das Nações',
  'U20 World Cup': 'Campeonato do Mundo U20',
  'The Draw': 'Empate',
  'Under 2.5 Goals': 'Menos 2.5 Golos',
  'Over 2.5 Goals': 'Mais 2.5 Golos',
  'UEFA U21 Championship': 'Campeonato da Europa U21',
  'UEFA U19 Championship': 'Campeonato da Europa U19',
  'UEFA U17 Championship': 'Campeonato da Europa U17',
  //EUROPA
  'Azerbaijan': 'Azerbaijão',
  'Belgium': 'Bélgica',
  'Croatia': 'Croácia',
  'Cyprus': 'Chipre',
  'Czech Republic': 'República Checa',
  'Denmark': 'Dinamarca',
  'Finland': 'Finlândia',
  'France': 'França',
  'Germany': 'Alemanha',
  'Greece': 'Grécia',
  'Hungary': 'Hungria',
  'Iceland': 'Islândia',
  'Ireland': 'Irlanda',
  'Italy': 'Itália',
  'Kazakhstan': 'Cazaquistão',
  'Latvia': 'Letônia',
  'Lithuania': 'Lituânia',
  'Luxembourg': 'Luxemburgo',
  'Moldova': 'Moldávia',
  'Netherlands': 'Holanda',
  'North Macedonia': 'Macedónia do norte',
  'Norway': 'Noruega',
  'Poland': 'Polónia',
  'Romania': 'Romenia',
  'Serbia': 'Sérvia',
  'Slovakia': 'Eslováquia',
  'Slovenia': 'Eslovénia',
  'Spain': 'Espanha',
  'Sweden': 'Suécia',
  'Switzerland': 'Suiça',
  'Turkey ': 'Turquia',
  'Ukraine': 'Ucrânia',
  'United Kingdom': 'Reino Unido',
  'England': 'Inglaterra',
  'Wales': "País de Gales",
  'Scotland': 'Escócia',
  //ÁMERICAS
  'United States': 'Estados Unidos',
  'Brazil': 'Brasil',
  'Mexico': 'México',
  'Colombia': 'Colómbia',
  'Canada': 'Canadá',
  'Ecuador': 'Equador',
  'Dominican Republic': 'República dominicana',
  'Paraguay': 'Paraguai',
  'Panama': 'Panamá',
  'Puerto Rico': 'Porto Rico',
  'Uruguay': 'Uruguai',
  //ÁFRICA
  'Nigeria': 'Nigéria',
  'Ethiopia': 'Etiópia',
  'Egypt': 'Egito',
  'Democratic Republic of the Congo': 'República democrática do congo',
  'South Africa': 'África do Sul',
  'Sudan': 'Sudão',
  'Algeria': 'Argélia',
  'Morocco': 'Marrocos',
  'Mozambique': 'Moçambique',
  'Ghana': 'Gana',
  'Ivory Coast': 'Costa de Marfim',
  'Cameroon': 'Camarões',
  'Guinea': 'Guiné',
  'Sierra Leone': 'Serra Leoa',
  'Libya': 'Libía',
  'Republic of the Congo': 'República do Congo',
  'Central African Republic': 'República Central Africana',
  'Liberia': 'Libéria',
  'Gambia': 'Gâmbia',
  'Gabon': 'Gabão',
  'Guinea-Bissau': 'Guiné-Bissau',
  //ÁSIA
  'Philippines': 'Filipinas',
  'Iran': 'Irão',
  'Thailand': 'Tailândia',
  'Myanmar': 'Birmânia',
  'South Korea': 'Coreia do Sul',
  'Afghanistan': 'Afeganistão',
  'Iraq': 'Iraque',
  'Uzbekistan': 'Uzbequistão',
  'Malaysia': 'Malásia',
  'Saudi Arabia': 'Arábia Saudita',
  'Yemen': 'Iémen',
  'North Korea': 'Coreia do Norte',
  'Syria': 'Síria',
  'Tajikistan': 'Tajiquistão',
  'United Arab Emirates': 'Emirados Árabes Unidos',
  'Jordan': 'Jordãnia',
  'Singapore': 'Singapura',
  'Japan': 'Japão',
  //SUB-21
  'Germany U21': 'Alemanha U21',
  'England U21': 'Inglaterra U21',
  'Spain U21': 'Espanha U21',
  'France U21': 'França U21',
  'Azerbaijan U21': 'Azerbeijão U21',
  'Belgium U21': 'Bélgica U21',
  'Croatia U21': 'Croácia U21',
  'Cyprus U21': 'Chipre U21',
  'Czech Republic U21': 'República Checa U21',
  'Denmark U21': 'Dinamarca U21',
  'Estonia U21': 'Estónia U21',
  'Finland U21': 'Finlandia U21',
  'Greece U21': 'Grécia U21',
  'Hungary U21': 'Hungria U21',
  'Iceland U21': 'Islândia U21',
  'Italy U21': 'Itália U21',
  'Kazakhstan U21': 'Casaquistão U21',
  'Latvia U21': 'Letônia U21',
  'Lithuania U21': 'Lituânia U21',
  'Luxembourg U21': 'Luxamburgo U21',
  'Moldova U21': 'Moldávia U21',
  'Netherlands U21': 'Holanda U21',
  'North Macedonia U21': 'Macedónia do norte U21',
  'Northern Ireland  U21': 'Irlanda do Norte U21',
  'Norway U21': 'Noruega U21',
  'Poland U21': 'Polónia U21',
  'Republic of Ireland U21': 'República da Irlanda U21',
  'Scotland U21': 'Escócia U21',
  'Serbia U21': 'Sérvia U21',
  'Slovakia U21': 'Eslováquia U21',
  'Slovenia U21': 'Eslovénia U21',
  'Sweden U21': 'Suécia U21',
  'Switzerland U21': 'Suiça U21',
  'Turkey U21': 'Turquia U21',
  'Ukraine U21': 'Ucrânia U21',
  'Wales U21': 'País de Gales U21',
}

export function translate(key) {
  if (pt.hasOwnProperty(key)) {
    return pt[key]
  } else {
    return key
  }
}